export default "__VITE_ASSET__WgI$eFdQ__"